import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import classnames from 'classnames'

import ErrorMessageSevere from './error-message-severe'
import ErrorMessageUser from './error-message-user'

import styles from './error-message.css'

import CrossIcon from '../../../assets/icons/cross.svg'

const ErrorMessage = ({
  error,
  id,
  lastEventId,
  market,
  isFixed,
  isSmall,
  resetErrorMessage,
}) => (
  <ReactCSSTransitionGroup
    transitionAppear
    transitionAppearTimeout={200}
    transitionEnterTimeout={200}
    transitionLeaveTimeout={100}
    transitionName="error-message"
  >
    <div
      key={id}
      styleName={classnames({
        container: error && error.detail,
        'container-fixed': isFixed,
        'container-sm': isSmall,
      })}
    >
      {error && error.detail &&
        <div>
          <div styleName="content">
            <div styleName="description">
              {
                error.severe ?
                  <ErrorMessageSevere error={error} lastEventId={lastEventId} market={market} /> :
                  <ErrorMessageUser error={error} />
              }
            </div>
          </div>
          <button styleName="cross" onClick={resetErrorMessage}><CrossIcon /></button>
        </div>
      }
    </div>
  </ReactCSSTransitionGroup>
)

ErrorMessage.propTypes = {
  error: PropTypes.object,
  id: PropTypes.string,
  lastEventId: PropTypes.any,
  market: PropTypes.object,
  isFixed: PropTypes.bool,
  isSmall: PropTypes.bool,
  resetErrorMessage: PropTypes.func,
}

export default CSSModules(ErrorMessage, styles, { allowMultiple: true })



/** WEBPACK FOOTER **
 ** ./src/components/error-message/error-message.js
 **/